export { default } from './Pagination';


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/rc-pagination/es/index.js
// module id = 1418
// module chunks = 0